module.exports = __webpack_public_path__ + "img/hic-respiratory-diseases-male.491d27e9.png";